export default "__VITE_ASSET__a81d7a50__"